import { GameType } from "../types";

export default function clearDeepLink(
  deepLink: { game: GameType | null } | null,
  setSelectedGame: (name: GameType | null) => void,
) {
  if (!deepLink) return;

  const url = new URL(window.location.href);

  url.searchParams.delete("page");

  if (deepLink.game) {
    setSelectedGame(deepLink.game);
    url.pathname = "/game";
  }

  window.history.replaceState(null, "", `${url.pathname}${url.search}`);
}
